import { FC } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useSetDefaultDashboardMutation } from "../../../api/network/overviewApiServices";
import { setModalsData, TModalsState } from "../../../api/store/commonSlice";
import svgIcons from "../../../assets/svg/svgIcons";
import { AdminFormFieldSubmit } from "../../../components/admin/formFields";
import { useOverviewContext } from "../context/overview.context";

type TDashboardSelectorDropdownProps = {
  isLoadingDeleteDashboard?: boolean;
  setDashboardIdForDelete?: (id: number) => void;
  onSelection?: () => void;
}

const DashboardSelectorDropdown: FC<TDashboardSelectorDropdownProps> = ({
  isLoadingDeleteDashboard,
  setDashboardIdForDelete,
  onSelection
}) => {
  const dispatch = useDispatch();
  const modalsState: TModalsState = useSelector(
    (state: any) => state.commonReducer.modals
  );
  const {
    selectedDashboard,
    dashList,
    setSelectedDashboard,
  } = useOverviewContext();

  const [setDefaultDashboardAPITrigger, { isLoading: isLoadingSetDefaultDashboard }] = useSetDefaultDashboardMutation();

  return (
    <div className="absolute top-full left-0 bg-white rounded-lg flex flex-col px-3 py-3 mt-2 w-80 shadow-lg border border-black/10 z-popup">
      <ul className="flex flex-col gap-3 text-sm max-h-[calc(100vh-240px)] overflow-auto">
        {dashList?.map((dashboardItem, index) => (
          <li key={index} className="flex gap-1">
            <button type="button"
              className={`flex-grow text-left px-3 rounded-lg overflow-hidden whitespace-nowrap text-ellipsis ${dashboardItem.id === selectedDashboard ? 'bg-accent-blue-paleO66' : 'hover:bg-accent-blue-paleO66'}`}
              onClick={() => {
                setSelectedDashboard(dashboardItem.id)
                dispatch(setModalsData({
                  ...modalsState,
                  showDashboardSelectorDropdown: false,
                }));
                onSelection?.()
              }}
            >
              {dashboardItem.name}
            </button>
            <button type="button"
              className={`shrink-0 flex justify-center items-center size-9 rounded-lg enabled:hover:bg-accent-blue-paleO66${isLoadingSetDefaultDashboard ? ' grayscale' : ''}`}
              onClick={() => {
                // setStarredDashboard(dashboardItem.id)
                setDefaultDashboardAPITrigger(dashboardItem.id)
              }}
              disabled={isLoadingSetDefaultDashboard}
            >
              <img src={dashboardItem.is_default ? svgIcons.StarFilledBlue : svgIcons.StarOutline} alt="" />
            </button>
            <button type="button"
              className="shrink-0 flex justify-center items-center size-9 rounded-lg hover:bg-accent-blue-paleO66"
              onClick={() => {
                dispatch(setModalsData({
                  ...modalsState,
                  showDashboardSelectorDropdown: false,
                  showCreateDashboard: true,
                  editDashboardId: dashboardItem.id
                }));
              }}
            >
              <img src={svgIcons.EditIcon} alt="" />
            </button>
            <button type="button"
              className={`shrink-0 flex justify-center items-center size-9 rounded-lg hover:bg-field-error-dark/10${isLoadingDeleteDashboard ? ' grayscale' : ''}`}
              onClick={() => {
                setDashboardIdForDelete?.(dashboardItem.id)
                dispatch(setModalsData({
                  ...modalsState,
                  // showDashboardSelectorDropdown: false,
                  showDeleteConfirmation: true
                }))
              }}
              disabled={isLoadingDeleteDashboard}
            >
              <img src={svgIcons.Delete} alt="" className="size-4" />
            </button>
          </li>
        ))}
      </ul>
      <hr className="my-2" />
      <AdminFormFieldSubmit
        label={"Add New Dashboard"}
        variant="primary-like"
        onClick={() => {
          dispatch(setModalsData({
            ...modalsState,
            showDashboardSelectorDropdown: false,
            showCreateDashboard: true
          }))
          onSelection?.();
        }}
      />
    </div>
  );
}
export default DashboardSelectorDropdown;